import "core-js/modules/es.array.some.js";
import "core-js/modules/es.object.to-string.js";
import { z } from 'zod';
var JsonLogicVar = z.object({
  "var": z.string()
});
var JsonLogicNot = z.object({
  '!': JsonLogicVar
});
var JsonLogicEqualsString = z.object({
  '==': z.tuple([JsonLogicVar, z.string()])
});
var JsonLogicEqualsNumber = z.object({
  '==': z.tuple([JsonLogicVar, z.number()])
});
var JsonLogicNotEqualsString = z.object({
  '!=': z.tuple([JsonLogicVar, z.string()])
});
var JsonLogicNotEqualsNumber = z.object({
  '!=': z.tuple([JsonLogicVar, z.number()])
});
export var JsonLogicInStringArray = z.object({
  "in": z.tuple([JsonLogicVar, z.string().array()])
});
export var JsonLogicInNumberArray = z.object({
  "in": z.tuple([JsonLogicVar, z.number().array()])
});
var JsonLogicLessThan = z.object({
  '<': z.tuple([JsonLogicVar, JsonLogicVar])
});
var JsonLogicGreaterThan = z.object({
  '>': z.tuple([JsonLogicVar, JsonLogicVar])
});
var JsonLogicLessThanOrEqualTo = z.object({
  '<=': z.tuple([JsonLogicVar, JsonLogicVar])
});
var JsonLogicGreaterThanOrEqualTo = z.object({
  '>=': z.tuple([JsonLogicVar, JsonLogicVar])
});
var JsonLogicBoolean = z.object({
  '==': z.tuple([JsonLogicVar, z["boolean"]()])
});
var JsonLogicIncludes = z.object({
  "in": z.tuple([z.string(), JsonLogicVar])
});
export var JsonLogicSimpleOperations = z.union([JsonLogicBoolean, JsonLogicEqualsString, JsonLogicEqualsNumber, JsonLogicNotEqualsString, JsonLogicNotEqualsNumber, JsonLogicGreaterThan, JsonLogicGreaterThanOrEqualTo, JsonLogicInNumberArray, JsonLogicInStringArray, JsonLogicLessThan, JsonLogicLessThanOrEqualTo, JsonLogicNot, JsonLogicIncludes]);
export var JsonLogicEnumOperations = z.union([JsonLogicEqualsString, JsonLogicEqualsNumber, JsonLogicNotEqualsString, JsonLogicNotEqualsNumber, JsonLogicInNumberArray, JsonLogicInStringArray]);
var JsonLogicAnd = z.object({
  and: z.array(z.union([JsonLogicSimpleOperations, JsonLogicEnumOperations]))
});
export var JsonLogicFilter = z.object({
  filter: z.tuple([JsonLogicVar, JsonLogicAnd])
});
var JsonLogicAll = z.object({
  none: z.tuple([z.union([JsonLogicVar, JsonLogicFilter]), z.object({
    '!': z.tuple([z.union([JsonLogicSimpleOperations, JsonLogicEnumOperations])])
  })])
});
export var JsonLogicAllWithFilter = z.object({
  none: z.tuple([JsonLogicFilter, z.object({
    '!': z.tuple([z.union([JsonLogicSimpleOperations, JsonLogicEnumOperations])])
  })])
});
var JsonLogicSome = z.object({
  some: z.preprocess(function (data) {
    var result = JsonLogicLegacyTagsStructure.safeParse(data);
    if (result.success) {
      return convertLegacyTagsStructureToModernStructure(result.data);
    }
    return data;
  }, z.tuple([z.union([JsonLogicVar, JsonLogicFilter]), z.union([JsonLogicSimpleOperations, JsonLogicEnumOperations])]))
});
var JsonLogicLegacyTagsStructure = z.tuple([z.object({
  "var": z.string()
}), z.object({
  and: z.tuple([z.object({
    some: z.tuple([z.object({
      "var": z.literal('tags')
    }), z.object({
      '==': z.tuple([z.object({
        "var": z.literal('')
      }), z.string()])
    })])
  }), z.unknown()])
})]);
export var JsonLogicLegacyBooleanStructure = z.object({
  "in": z.tuple([z.object({
    "var": z.string()
  }), z.array(z.union([z.literal('true'), z.literal('false')])).length(1)])
});

/**
 * Originally, we implemented `some` for only a specific case involving
 * `tags`. Since then, we've improved `JsonLogicInput` to support more
 * generic / complex `some` operations. This function converts the legacy
 * structure, which was highly specific to one use-case, to the more generic
 * structure that is meant to be used going forward.
 */
function convertLegacyTagsStructureToModernStructure(data) {
  return [{
    filter: [data[0], {
      and: [{
        "in": [data[1].and[0].some[1]['=='][1], {
          "var": 'tags'
        }]
      }]
    }]
  }, data[1].and[1]];
}
export var JsonLogicSomeWithFilter = z.object({
  some: z.tuple([JsonLogicFilter, z.union([JsonLogicSimpleOperations, JsonLogicEnumOperations])])
});
export var JsonLogicArrayOperations = z.union([JsonLogicAll, JsonLogicSome]);
export var JsonLogicArrayFilterOperations = z.union([JsonLogicAllWithFilter, JsonLogicSomeWithFilter]);
export var JsonLogic = z.union([JsonLogicAll, JsonLogicBoolean, JsonLogicEqualsString, JsonLogicEqualsNumber, JsonLogicNotEqualsString, JsonLogicNotEqualsNumber, JsonLogicGreaterThan, JsonLogicGreaterThanOrEqualTo, JsonLogicInNumberArray, JsonLogicInStringArray, JsonLogicLessThan, JsonLogicLessThanOrEqualTo, JsonLogicNot, JsonLogicSome, JsonLogicIncludes]);